import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ShopRoute = () => {
    const { userInfo } = useSelector(state => state.auth);
    return userInfo?.role === 'shop' ? <Outlet /> : <Navigate to='/login' replace />;
};

export default ShopRoute;